<div class="page-container">
  <!-- Page -->
  <div class="d-flex flex-column flex-grow-1">
    <header class="header-bold">
      <div class="center-layout-wide">
        <h1>Create Your Payroll Login</h1>
      </div>
    </header>

    <div class="main-content cta-container center-layout-wide">
      <div *ngIf="!vm.isSuccess" class="validationError invalid-feedback feedback">
        <ng-container *ngFor="let validationError of vm.validationErrors">
          <p class="at-error" style="color: red !important">
            <span><i class="fas fa-exclamation-circle fa-lg icon" style="top: 0px"></i></span>
            <span class="ml-3">{{ validationError.description }}</span>
          </p>
        </ng-container>
      </div>

      <form #form="spForm" [spForceFeedback]="spForceFeedback">
        <sp-model [model]="vm" modelType="ClientRegistration">
          <p><i>Please confirm your identifying information.</i></p>

          <sp-input name="lastName" [autofocus]="true" propertyName="lastName" label="Last Name" placeholder="Last Name"
            [disabled]="disabled">
          </sp-input>
          <sp-input name="fein" propertyName="fein" label="Last 4 digits of your Federal Employer Identification number"
            placeholder="Fein" [spValidationStatus]="feinInput" #feinInput="ngModel" [(ngModel)]="vm.fein"
            [disabled]="disabled">
          </sp-input>
          <p *ngIf="!vm.isEmailUser"><i>Pick a unique username and password for your account.</i></p>
          <sp-input *ngIf="!vm.isEmailUser" name="username" propertyName="username" label="Username"
            placeholder="Username" [disabled]="disabled">
            <ng-container helpTextAbove>
              <div class="input-help-text create-login-help">
                Your username must be between 8 and 18 characters long.
              </div>
            </ng-container>
          </sp-input>
          <sp-input name="email" *ngIf="vm.isEmailUser && !vm.isEntityChange" propertyName="email" label="Email"
            placeholder="Email" [disabled]="true">
            <ng-container helpTextAbove>
              <div class="input-help-text create-login-help">
                Your email must be unique.
              </div>
            </ng-container>
          </sp-input>
          <sp-input name="email" *ngIf="vm.isEmailUser && vm.isEntityChange" propertyName="email" label="Email"
            placeholder="Email" [disabled]="disabled">
            <ng-container helpTextAbove>
              <div class="input-help-text create-login-help">
                Your email must be unique.
              </div>
            </ng-container>
          </sp-input>
          <sp-input name="password" [type]="showPassword ? 'text' : 'password'" propertyName="password" label="Password"
            placeholder="Password" (keyup)="handlePassword($event, true)" [disabled]="disabled">
            <ng-container inputActionIcon>
              <span toggle="#Password" class="fa fa-fw field-icon toggle-password"
                [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="showPassword=!showPassword"></span>
            </ng-container>
          </sp-input>
          <sp-input name="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
            propertyName="confirmPassword" label="Confirm Password" (keyup)="handlePassword($event, false)"
            placeholder="Confirm Password" [disabled]="disabled">
            <ng-container inputActionIcon>
              <span toggle="#Password" class="fa fa-fw field-icon toggle-password"
                [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
                (click)="showConfirmPassword=!showConfirmPassword"></span>
            </ng-container>
          </sp-input>
          <div>
            <sp-password-policy [Policy]="Policy" [Password]="newPassword" [ConfirmPassword]="reEnterPassword"
              [IsOldPassword]="isOldPassword">
            </sp-password-policy>
          </div>
          <div class="form-group d-flex align-items-center justify-content-between">
            <sp-button [btn]="btn.Primary" (onClick)="createAccount()" [disabled]="disabled"
              extraClasses="create-login-btn" id="create-login-btn-wrapper">
              Continue
            </sp-button>
          </div>
        </sp-model>
      </form>
    </div>
  </div>
</div>
